import React, { useState, useEffect, Children } from 'react'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../utils/loading'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import { getAssessmentReportPage } from '../../redux/actions/assessment'
import AssessmentReportDynamicWidgets from '../../widgets/assessment/AssessmentReportDynamicWidgets'

export default function ReportPartnerStrength() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getAssessmentReportPage(1, 1, 5)
      setSchema(response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isAssessment>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAssessment>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isAssessment>
      <ContentHeader header={schema.header} isNotCallApi />
      {schema && <AssessmentReportDynamicWidgets schema={schema} type={1} />}
    </SidebarProposal>
  )
}

const mocSchema = {
  header: 'ความเข้มแข็งภาคี',
  searchForm: [
    {
      name: 'contractNo',
      label: 'เลขที่สัญญา',
      type: '1',
    },
    {
      name: 'projectCode',
      label: 'รหัสโครงการ',
      type: '1',
    },
    {
      name: 'projectName',
      label: 'ชื่อโครงการ',
      type: '1',
    },
    {
      name: 'email',
      label: 'อีเมล์ผู้ตอบแบบประเมิน',
      type: '1',
    },
    {
      name: 'evaluationDate',
      label: 'วันที่ทำประเมิน',
      type: '3',
    },
    {
      name: 'department',
      label: 'สำนัก',
      type: '2',
      options: [{ value: '01', label: 'สำนัก 1' }],
    },
  ],
  resultData: {
    columnConfig: [
      {
        key: 'projectCode',
        label: 'รหัสโครงการ',
        width: 120,
        align: 'center',
        seq: 1,
      },
      {
        key: 'contractNo',
        label: 'เลขที่สัญญา',
        align: 'center',
        width: 120,
        seq: 1,
      },
      {
        key: 'projectName',
        label: 'ชื่อโครงการ',
        width: 300,
        seq: 1,
      },
      {
        key: 'budgetYear',
        label: 'ปีงบอนุมัติ',
        align: 'center',
        width: 150,
        seq: 1,
      },
      {
        key: 'approveBudget',
        label: 'งบอนุมัติ',
        align: 'right',
        width: 200,
        seq: 1,
      },
      {
        key: 'projectStartDate',
        label: 'วันเริ่มต้นโครงการ',
        align: 'center',
        width: 150,
        seq: 1,
      },
      {
        key: 'projectEndDate',
        label: 'วันสิ้นสุดโครงการ',
        align: 'center',
        width: 150,
        seq: 1,
      },
      {
        key: 'projectDuration',
        label: 'ระยะเวลาดำเนินโครงการ',
        width: 200,
        seq: 1,
      },
      {
        key: 'department',
        label: 'สำนัก',
        width: 200,
        seq: 1,
      },
      {
        key: 'coordinator',
        label: 'ผู้ประสานงาน',
        width: 200,
        seq: 1,
      },
      {
        key: 'projectType',
        label: 'ประเภทโครงการ',
        width: 200,
        seq: 1,
      },
      {
        key: 'granteeType',
        label: 'ประเภทผู้รับทุน',
        width: 200,
        seq: 1,
      },
      {
        key: 'orgType',
        label: 'ประเภทองค์กรย่อย',
        width: 200,
        seq: 1,
      },
      {
        key: 'responsible',
        label: 'ผู้รับผิดชอบโครงการ',
        width: 200,
        seq: 1,
      },
      {
        key: 'responsibleMobileNo',
        label: 'เบอร์มือถือผู้รับผิดชอบโครงการ',
        width: 200,
        seq: 1,
      },
      {
        key: 'responsibleEmail',
        label: 'อีเมลผู้รับผิดชอบโครงการ',
        width: 200,
        seq: 1,
      },
      {
        key: 'assessmentEmail',
        label: 'อีเมล์ผู้ตอบแบบประเมิน',
        width: 200,
        seq: 1,
      },
      {
        key: 'assessmentDate',
        label: 'วันที่ทำประเมิน',
        width: 150,
        seq: 1,
      },
      {
        key: 'assessments',
        label: 'แบบประเมิน',
        width: 0,
        seq: 1,
        children: [
          {
            key: '1',
            label: 'ผลประเมิน ข้อ 1',
            width: 200,
            seq: 1,
          },
          {
            key: '2',
            label: 'ผลประเมิน ข้อ 2',
            width: 200,
            seq: 1,
          },
        ],
      },
    ],
    total: 1,
    values: [
      {
        rowNum: 1,
        projectCode: '1',
        contractNo: '2',
        projectName: '3',
        budgetYear: '2025',
        approveBudget: 100000,
        projectStartDate: '',
        projectEndDate: '',
        projectDuration: '',
        department: '',
        coordinator: '',
        projectType: '',
        granteeType: '',
        orgType: '',
        responsible: '',
        responsibleMobileNo: '',
        responsibleEmail: '',
        assessmentEmail: '',
        assessmentDate: '',
        assessments: ['1', '2'],
      },
    ],
  },
}
